import { create } from 'zustand';

export const useStore = create((set) => ({
  activeUser: null,
  activeChannel: null,
  showTaskPanel: false,
  activeTaskId: null,
  activeTaskData: null,
  messages: [],
  typingUsers: {}, // { [channelId]: { [userId]: username } }
  unreadCounts: {}, // { [channelId]: count }
  drafts: {}, // { [channelId]: text }
  presence: {}, // { [userId]: { presence_status, custom_status_msg, full_name, avatar_color } }
  users: [], // cache for resolving usernames
  socket: null,
  incomingCall: null, // { callerId, callerName, callerAvatar, channelId }
  pendingHuddleJoin: null, // channelId

  setIncomingCall: (callInfo) => set({ incomingCall: callInfo }),
  setPendingHuddleJoin: (channelId) => set({ pendingHuddleJoin: channelId }),

  setActiveUser: (user) => set({ activeUser: user }),
  setActiveChannel: (channel) => set({ activeChannel: channel }),
  toggleTaskPanel: (show) => set((state) => ({ showTaskPanel: show !== undefined ? show : !state.showTaskPanel })),
  setActiveTaskId: (taskId) => set({ activeTaskId: taskId, showTaskPanel: !!taskId }),
  clearActiveTask: () => set({ activeTaskId: null, showTaskPanel: false, activeTaskData: null }),
  setActiveTaskData: (activeTaskData) => set({ activeTaskData }),
  updateActiveTaskData: (changes) => set((state) => {
    if (!state.activeTaskData) return {};
    return { activeTaskData: { ...state.activeTaskData, ...changes } };
  }),
  setUsers: (users) => set({ users }),
  setSocket: (socket) => set({ socket }),
  setPresence: (userId, status, customStatusMsg) => set((state) => {
    const prev = state.presence[userId] || {};
    return {
      presence: {
        ...state.presence,
        [userId]: {
          ...prev,
          presence_status: status,
          ...(customStatusMsg !== undefined ? { custom_status_msg: customStatusMsg } : {})
        }
      }
    };
  }),
  setAllPresence: (presence) => set({ presence }),
  
  setMessages: (messages) => set((state) => ({
    messages: typeof messages === 'function' ? messages(state.messages) : messages
  })),
  addMessage: (message) => set((state) => {
    if (state.messages.some((m) => m.id === message.id)) return {};
    // Ensure status defaults to delivered if not present
    const messageWithStatus = { status: 'delivered', ...message };
    return { messages: [...state.messages, messageWithStatus] };
  }),
  setTypingStatus: (channelId, userId, userName, isTyping) => set((state) => {
    const channelTyping = { ...(state.typingUsers[channelId] || {}) };
    if (isTyping) {
      channelTyping[userId] = userName;
    } else {
      delete channelTyping[userId];
    }
    return {
      typingUsers: {
        ...state.typingUsers,
        [channelId]: channelTyping
      }
    };
  }),
  incrementUnread: (channelId) => set((state) => {
    const current = state.unreadCounts[channelId] || 0;
    return {
      unreadCounts: {
        ...state.unreadCounts,
        [channelId]: current + 1
      }
    };
  }),
  clearUnread: (channelId) => set((state) => ({
    unreadCounts: {
      ...state.unreadCounts,
      [channelId]: 0
    }
  })),
  setDraft: (channelId, text) => set((state) => {
    const nextDrafts = { ...state.drafts, [channelId]: text };
    localStorage.setItem('tm_drafts', JSON.stringify(nextDrafts));
    return { drafts: nextDrafts };
  }),
  loadDrafts: () => set(() => {
    try {
      const saved = localStorage.getItem('tm_drafts');
      return saved ? { drafts: JSON.parse(saved) } : {};
    } catch {
      return {};
    }
  })
}));
